import { YOUR_IMAI_COLOR_SEED_BY_NAME } from './persona.helpers';

/** The colour seeds the picker offers; the avatar route draws no other. */
export function isYourImaiColorSeed(seed: string): boolean {
  return Object.values(YOUR_IMAI_COLOR_SEED_BY_NAME).some(
    (known) => known === seed
  );
}

/**
 * Same-origin path of a Your IMAI face as a notification icon
 * (src/app/api/your-imai/avatar). Only the look goes in the URL; missing
 * parts take the default look there.
 */
export function yourImaiAvatarIconPath(
  persona:
    | {
        shape?: string;
        expression?: string;
        backgroundStyle?: string;
        colorSeed?: string;
      }
    | null
    | undefined
): string {
  const params = new URLSearchParams();
  if (persona?.shape) params.set('shape', persona.shape);
  if (persona?.expression) params.set('expression', persona.expression);
  if (persona?.backgroundStyle) params.set('bg', persona.backgroundStyle);
  if (persona?.colorSeed && isYourImaiColorSeed(persona.colorSeed))
    params.set('seed', persona.colorSeed);
  const query = params.toString();
  return `/api/your-imai/avatar${query ? `?${query}` : ''}`;
}
